import React, { Fragment } from "react";
import Container from "react-bootstrap/Container";
import CardCarousel from "./CardCarousel/CardCarousel";
import "./Blog.css";
import Fade from "react-reveal/Fade";

const h1Style = {
  color: "#ff5b56",
  fontStyle: "Roboto",
  fontWeight: "bold",
  lineHeight: "1.42",
  letterSpacing: "1.3px",
  textAlign: "center",
  paddingTop: "20px",
  marginBottom: "4.5%"
};

const blog = () => {
  return (
    <div className="blog">
      <Container className="blog-container-wrap">
        <h1 style={h1Style}>
          <Fade delay={300}>Blogs</Fade>
        </h1>
        <br />
        <div className="card-carousel-wr">
          <CardCarousel />
        </div>
      </Container>
    </div>
  );
};

export default blog;
